import { Axios } from "@/Services/Axios";
import { AxiosResponse } from "axios";
import { useQuery } from "@tanstack/react-query";
import { BasicQueryType } from "@/Utils/RequisicaoUtilitario";
import { Parametros as ParametrosDosTitulosAcumulados, Resultado as ResultadoDosTitulosAcumulados } from "@/Models/Financeiro/Titulo/Relatorios/RelatorioDeTitulosAcumulados";
import { Parametros as ParametrosDaVisaoMensal, RetornoDaQuery as ResultadoDaVisaoMensal } from "@/Models/Financeiro/Titulo/Relatorios/RelatorioDeVisaoMensalDosTitulos";
import { Filtro as FiltroDaVisaoGeralDeMovimentacoes, Resultado as ResultadoDaVisaoGeralDeMovimentacoes } from "@/Models/Financeiro/Titulo/Relatorios/RelatorioDeVisaoGeralDeMovimentacoes";
import Pagina, { IPaginaInfo } from "@/Models/Utils/Pagina/Pagina";

export class RelatorioService {
    public static gerarRelatorioDaVisaoDeTitulos1_Todos(filtro?: FiltroDaVisaoGeralDeMovimentacoes) {
        return Axios.get<ResultadoDaVisaoGeralDeMovimentacoes[]>("quiron/relatorios/financeiro/movimentacao-geral/todos", { params: filtro });
    }
}

export function useGerarRelatorioDeTitulosAcumulados(
    config: BasicQueryType<AxiosResponse<ResultadoDosTitulosAcumulados>>,
    filtro?: ParametrosDosTitulosAcumulados
){

    const query = useQuery({
        queryKey: ["Financeiro.Titulo.Relatorios", "Financeiro.Titulo.Relatorios.Acumulado", filtro],
        queryFn: async () => {
            return Axios.get<ResultadoDosTitulosAcumulados>("quiron/relatorios/financeiro/acumulado", {
                params: filtro,
            });
        },
        gcTime: 0,
        enabled: false,
        ...config,
    });

    return query;
}

export function useGerarRelatorioDeVisaoMensal(
    config: BasicQueryType<AxiosResponse<ResultadoDaVisaoMensal>>,
    filtro?: ParametrosDaVisaoMensal
){

    const query = useQuery({
        queryKey: ["Financeiro.Titulo.Relatorios", "Financeiro.Titulo.Relatorios.VisaoMensal", filtro],
        queryFn: async () => {
            return Axios.get<ResultadoDaVisaoMensal>("quiron/relatorios/financeiro/visao-mensal", {
                params: filtro,
            });
            
        },
        gcTime: 0,
        enabled: false,
        ...config,
    });

    return query;
}

export function useGerarRelatorioDeVisaoGeralDeMovimentacoes_ComPaginacao(
    config: BasicQueryType<AxiosResponse<Pagina<ResultadoDaVisaoGeralDeMovimentacoes>>>,
    parametros: {
        pagina: IPaginaInfo,
        filtro?: FiltroDaVisaoGeralDeMovimentacoes
    }
){
    const params = {
        pagina: { ...parametros.pagina },
        filtro: {...parametros.filtro},
    };

    const query = useQuery({
        queryKey: ["Financeiro.Titulo.Relatorios", "Financeiro.Titulo.Relatorios.VisaoGeralDeMovimentacoes", params],
        queryFn: async () => {
            return Axios.get<Pagina<ResultadoDaVisaoGeralDeMovimentacoes>>("quiron/relatorios/financeiro/movimentacao-geral", {
                params,
                paramsSerializer: {
                    indexes: null,
                    dots: true,
                },
            });
        },
        gcTime: 0,
        enabled: false,
        ...config,
    });

    return query;
}